// swiper
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Initialize partners swiper
const partnersSwipers = document.querySelectorAll(".swiper-partners");
if (partnersSwipers.length > 0) {
  partnersSwipers.forEach((swiper, index) => {
    new Swiper(swiper, {
      modules: [Autoplay],
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 24,
      watchSlidesProgress: true,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: true,
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
    });
  });
}

const imagesSwipers = document.querySelectorAll(".swiper-images");
if (imagesSwipers.length > 0) {
  imagesSwipers.forEach((swiper, index) => {
    new Swiper(swiper, {
      modules: [Autoplay, Navigation],
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: 24,
      watchSlidesProgress: true,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: swiper.querySelector(".swiper-button-next"),
        prevEl: swiper.querySelector(".swiper-button-prev"),
      },
    });
  });
}
